import { render, staticRenderFns } from "./BlockSubscriptions.vue?vue&type=template&id=46704bee&"
import script from "./BlockSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./BlockSubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports